// @flow

import styled from 'styled-components';

import Input from '../Input';

export default styled(Input)`
  flex-grow: 1;
`;
